import React, { Component } from 'react';
import Container from '@gerenciatd/next.components.container';
import Content from '@gerenciatd/next.components.content'

export const LEGO_COMPONENTS = {
    BANNER: 'Banner',
    FEATURES_PRODUCTS: 'FeaturedProducts',
    PRODUCT_SUGGEST: 'ProductSuggest',
    SHOP_DEVICES: 'ShopDevices',
    TV_SLIDER: 'TvSlider',
    TEXTINFO: 'TextInfo',
    PRICE: 'Price',
    LABEL: 'Label',
    IMAGE: 'Image',
    SHORT_CLICK_TO_ACTION: 'ClickToConfig'
}

export const getComponentsOnThisLevel = (structure) => {
    const res = [];
    const keyNames = Object.keys(structure);
    keyNames.forEach(keyName => {
        const posibleCmp = getCmpUsingDelimiter(keyName);
        if (posibleCmp) {
            res.push(keyName)
        }
    })
    return res;  
}

export const getCmpUsingDelimiter = (delimiterStr) => {
    let delimiter = null;
    if (delimiterStr.indexOf('-') !== -1) {
        const delimiteToken = delimiterStr.split('-');
        delimiter =  delimiteToken[0];
    }
    return delimiter
}

class LegoComponent extends Component {
    constructor(props){
        super(props);
        const { dictionary } = props;

        this.state = {
            dictionary: {
                'Container': Container,
                'Content': Content,
                ...dictionary,
            }
        }
    }
    componentDidMount(){}

    getComponentByKey = (keyName) => {
        const { dictionary } = this.state;
        let delimiter = keyName;
        let Component = null;
        let placeHolder = false;

        const delimiterCmp = getCmpUsingDelimiter(delimiter);

        if (dictionary && dictionary[delimiterCmp]) {
            if (delimiterCmp === 'Container' || delimiterCmp === 'Content') {
                placeHolder = true;
            }
            Component = dictionary[delimiterCmp];
        }
    

        return {
            Component,
            placeHolder,
            delimiter,
            instance: keyName,
        }
    }

    renderFlow = (props, custoObjectInfo) => {
        const keys = Object.keys(props);
        return keys.map((propName, index) => {
            const currentProps = (props && props[propName]) || {};
            const {Component, placeHolder,  instance } = this.getComponentByKey(propName);
            
            if (Component && !placeHolder && props[propName]) {
                let componentCustoObjectInfo = null;
                if(custoObjectInfo) {
                    componentCustoObjectInfo = custoObjectInfo.addEntryPoint({
                        custoObjectInfo,
                        entryPoint: instance,
                      })
                }
                return (
                    <Component
                        {...props[propName]}
                        custoObjectInfo={componentCustoObjectInfo}
                    />
                )
            }

            if (Component && placeHolder) {
                let componentCustoObjectInfo = null;
                if(custoObjectInfo) {
                    componentCustoObjectInfo = custoObjectInfo.addEntryPoint({
                        custoObjectInfo,
                        entryPoint: `${instance}`,
                    })
                }
                const nextChildrenData = currentProps;
                return (
                    <Component {...currentProps} custoObjectInfo={componentCustoObjectInfo}>
                        {this.renderFlow(nextChildrenData, componentCustoObjectInfo)}
                    </Component>
                )
            }
            return null;
        })
    }

    render(){
        const { custoObjectInfo } = this.props;
        // console.log('primera estructura: ', { custoObjectInfo });
        return this.renderFlow(this.props, custoObjectInfo)
    }
}

export default LegoComponent;